<script>
    import {onMount} from "svelte";
    import {writable} from "svelte/store";
    import MenuItemTitle from "../FlyoutMenu/MenuItemTitle.svelte"
    
    import VesselCommentsView from './View.svelte';
    import ViewState from "./ViewState";

    export let threads = writable({});
    export let threadsDetails = writable({});
    export let viewing = writable(null);
    export let confirmDialog = null;

    onMount(() => {
        console.log("threads", $threads);
    });
</script>

<MenuItemTitle title={"Vessel Comments"} materialIcon={"comment"}></MenuItemTitle>

{#each Object.keys($threads) as spireId}
    {#if $viewing == spireId || $viewing == null}
        <hr/>
        <p><b>Vessel:</b> {$threadsDetails[spireId].name} ({$threadsDetails[spireId].imo}, {$threadsDetails[spireId].mmsi}) - {spireId}</p>
        <div class='p-10 mb-10'>
            <VesselCommentsView 
                confirmDialog={confirmDialog}
                useThreads={$threads[spireId]} 
                scrollable={false} 
                showAddThreadButton={false}
                on:viewStateChange={(e)=>{
                    // HACKS! When we click in, we only want to show the single thread! 
                    if (e.detail.viewState === ViewState.ALL) {
                        $viewing = null;
                    }
                    else {
                        $viewing = spireId;
                    }
                }}
                />
        </div>
    {/if}
{/each}
{#if Object.keys($threads).length === 0}
    <p>No Threads.</p>
{/if}